<template>
  <div class="flex w-full gap-0.5">
    <SingleRuleButton
      :active="activeButton === 'left' ? true : false"
      :stages="stages"
      :transferUser="transferUser"
      :assignedMember="assignedMember"
      :taskCreator="taskCreator"
      :rule="rules.secondary"
      :showMe=showMe
      :side="'left'"
      :currentStageId="currentStageId"
      @click="actionSecondaryClick"
    />
    <SingleRuleButton
      :active="activeButton === 'right' ? true : false"
      :stages="stages"
      :transferUser="transferUser"
      :taskCreator="taskCreator"
      :showMe=showMe
      :assignedMember="assignedMember"
      :rule="rules.primary"
      :side="'right'"
      :currentStageId="currentStageId"
      :shouldAutoClick="isCurrentUserActive"
      :autoclickStartPoint="autoclickStartPoint"
      @click="actionPrimaryClick"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import SingleRuleButton from '@/components/elements/SingleRuleButton';
import {
  EVENT__ASSIGN_MENTION,
} from '@/utils/constantHolder';

const props = defineProps({
  enableAutoClick: {
    type: Number,
    default: 0,
  },
  rules: Object,
  stages: Array,
  transferUser: null,
  assignedMember: null,
  taskCreator: null,
  showMe: null,
  currentStageId: String,
  isCurrentUserActive: Boolean,
  autoclickStartPoint: Number,
});
const emit = defineEmits(['primaryClick', 'secondaryClick']);

const store = useStore();

const getUser = computed(() => store.getters['user/getUser']);

const activeButton = computed(() => {
  if (!props.transferUser) {
    return 'right';
  }

  // const mentionRIGHT = this.rules.PRIMARY.find(x => x.action === EVENT__ASSIGN_MENTION);
  const mentionLEFT = props.rules.secondary.find(x => x.action === EVENT__ASSIGN_MENTION);

  if (mentionLEFT) {
    return 'left';
  }

  return 'right';
});

const actionPrimaryClick = () => {
  emit('primaryClick');
};
const actionSecondaryClick = () => {
  emit('secondaryClick');
};
</script>
